export default __webpack_public_path__ + "static/IBMPlexSans-Thin-Latin2-2243b2edbde6134acb946489df6f50fd.woff";